// src/pages/Profile.tsx
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const Profile: React.FC = () => {
  const [email] = useState('user@example.com'); // Replace with actual user data
  const [name] = useState('John Doe');
  const [role] = useState('Admin');
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState('');

  const navigate = useNavigate()


  const emailStored = localStorage.getItem('akjodem_email');
  const loggedInStored = localStorage.getItem('akjodem_isLoggedIn');
  
  useEffect(() => {
    if (!emailStored && !loggedInStored) {
      navigate('/login');
    }
  }, []);

  const handlePasswordChange = () => {


    if (!currentPassword || !newPassword || !confirmPassword) {
      alert('All field must be not be empty');
      return;
    }
    if (newPassword !== confirmPassword) {
      setMessage('New password and confirmation do not match.');
      return;
    }
    // Call an API to update the password
    fetch('https://akjodem.com/change_password.php', {
        method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ currentPassword, newPassword }),
      credentials: 'include',
    })
      .then(response => response.json())
      .then(data => {
        if (data.status === 'success') {
          alert('Password updated successfully')
          setCurrentPassword("");
          setNewPassword("");
          setConfirmPassword("");
        }
      })
      .catch(error => {
        console.error('Error:', error);
      });
  };

  return (
    <>
      {loggedInStored &&
        <div className="bg-gray-50 p-6 min-h-screen">
          <h1 className="mb-6 font-bold text-3xl">Profile</h1>
          <div className="gap-6 grid grid-cols-1 md:grid-cols-2">
            {/* Left Section: User Details */}
            <div className="bg-white shadow-md p-6 rounded-lg">
              {/* Profile Card */}
              <div className="flex items-center mb-6">
                <div className="ml-4">
                  <h2 className="font-bold text-xl">{role}</h2>
                  <p className="text-gray-500">{email}</p>
                </div>
              </div>
              {/* Additional Info */}

            </div>

            {/* Right Section: Password Update */}
            <div className="bg-white shadow-md p-6 rounded-lg">
              <h2 className="mb-4 font-bold text-2xl">Change Password</h2>
              {message && (
                <div
                  className={`p-2 mb-4 rounded text-sm ${message.includes('successfully')
                      ? 'bg-green-100 text-green-700'
                      : 'bg-red-100 text-red-700'
                    }`}
                >
                  {message}
                </div>
              )}
              <div>
                <div className="mb-4">
                  <label
                    htmlFor="currentPassword"
                    className="block font-medium text-gray-700 text-sm"
                  >
                    Current Password
                  </label>
                  <input
                    type="password"
                    id="currentPassword"
                    value={currentPassword}
                    onChange={(e) => setCurrentPassword(e.target.value)}
                    className="block shadow-sm mt-1 border-gray-300 focus:border-blue-500 rounded-md focus:ring-blue-500 w-full"
                    required
                  />
                </div>
                <div className="mb-4">
                  <label
                    htmlFor="newPassword"
                    className="block font-medium text-gray-700 text-sm"
                  >
                    New Password
                  </label>
                  <input
                    type="password"
                    id="newPassword"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                    className="block shadow-sm mt-1 border-gray-300 focus:border-blue-500 rounded-md focus:ring-blue-500 w-full"
                    required
                  />
                </div>
                <div className="mb-4">
                  <label
                    htmlFor="confirmPassword"
                    className="block font-medium text-gray-700 text-sm"
                  >
                    Confirm New Password
                  </label>
                  <input
                    type="password"
                    id="confirmPassword"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    className="block shadow-sm mt-1 border-gray-300 focus:border-blue-500 rounded-md focus:ring-blue-500 w-full"
                    required
                  />
                </div>
                <button
                  onClick={()=>handlePasswordChange()}
                  className="bg-blue-500 hover:bg-blue-600 px-4 py-2 rounded-lg w-full text-white transition-colors"
                >
                  Update Password
                </button>
              </div>
            </div>
          </div>
        </div>
      }
    </>
  );
};

export default Profile;
